/**
 * This enum defines the Google Analytics event names used in the Quote Tool Lite application.
 */
export enum GoogleAnalyticsEventEnum {
  QuoteFormError = 'quote_form_error',
  QuoteSubmissionFailure = 'quote_submission_failure',
  Course = 'quote_step_course',
  Extras = 'quote_step_extras',
  Applicant = 'quote_step_applicant',
  Quote = 'quote_step_quote',
  Booking = 'quote_step_booking',
  Confirmation = 'quote_step_confirmation',
  Payment = 'quote_step_payment',
  QuoteProgramTypeChange = 'quote_program_type_changed',
  QuoteEmailRegister = 'quote_email_register',
  QuoteCourseEdit = 'quote_course_edit',
  QuoteAccommodationAdd = 'quote_accommodation_add',
  QuoteAccommodationEdit = 'quote_accommodation_edit',
  QuoteAccommodationSeeMore = 'quote_accommodation_see_more',
  QuoteTransferAdd = 'quote_transfer_add',
  QuoteTransferEdit = 'quote_transfer_edit',
  QuoteTransferToggle = 'quote_transfer_toggle',
  QuoteInsuranceAdd = 'quote_insurance_add',
  QuoteInsuranceRemove = 'quote_insurance_remove',
  QuotePremiumResidenceAdd = 'quote_premium_residence_add',
  QuotePremiumResidenceRemove = 'quote_premium_residence_remove',
  QuoteUnaccompaniedMinorsAdd = 'quote_unaccompanied_minors_add',
  QuoteUnaccompaniedMinorsRemove = 'quote_unaccompanied_minors_remove',
  QuoteProfessionalImmersionExperienceAdd = 'quote_professional_immersion_experience_add',
  QuoteProfessionalImmersionExperienceRemove = 'quote_professional_immersion_experience_remove',
  QuotePrivateLessonsSelect = 'quote_private_lessons_select',
  QuotePremiumActivitiesSelect = 'quote_premium_activities_select',
  QuoteNext = 'quote_next',
  QuoteSaveAndClose = 'quote_save_and_close',
  QuoteBack = 'quote_back',
  QuoteUpsellingView = 'quote_upselling_view',
  QuoteUpsellingAccept = 'quote_upselling_accept',
  QuoteUpsellingDeny = 'quote_upselling_deny',
  QuoteCreateAnother = 'quote_create_another',
  QuoteCreateAnotherAccept = 'quote_create_another_accept',
  QuoteCreateAnotherReject = 'quote_create_another_reject',
  QuoteEnrol = 'quote_enrol',
  QuoteEmail = 'quote_email',
  QuoteUpdated = 'quote_updated',
  CopyLinkClicked = 'copy_link_clicked',
  DeeplinkOpened = 'deeplink_opened',
  OnlineCoursesWayfinderBannerClick = 'online_courses_wayfinder_banner_click',
}
